import { style } from '@vanilla-extract/css'

const badge = style({
  position: 'absolute',
  top: 0,
  left: 0,
  padding: '2px 8px',
  color: 'white',
  backgroundColor: 'var(--red-a11)',
  borderRadius: '8px 0 8px 0',
})

const thumbnail = style({
  objectFit: 'cover',
  aspectRatio: '0.767',
  borderRadius: '8px',
  maxWidth: '150px',
})

const dialogThumbnail = style({
  objectFit: 'cover',
  aspectRatio: '1',
  borderRadius: '8px',
})

const discountLabel = style({
  color: 'white',
  fontWeight: 'bold',
  backgroundColor: 'var(--red-a11)',
  borderRadius: '4px',
  padding: '2px 4px',
})

const selected = style({
  position: 'absolute',
  inset: 0,
  width: '100%',
  height: '100%',
  borderRadius: '8px',
  backgroundColor: 'rgba(51, 51, 51, 0.5)',
  color: 'white',
})

const selectedCheck = style({
  width: '27px',
  height: 'auto',
  margin: '12px',
})

export const styles = {
  badge,
  thumbnail,
  dialogThumbnail,
  discountLabel,
  selected,
  selectedCheck,
}
